import PropTypes from 'prop-types';
import Icon from "../Icon/Icon";
import cn from "../../../utils/cn";
import { isKeyPressed } from "../../../utils/isKeyPressed";
import { SPACEBAR_KEY_CODE, RETURN_KEY_CODE } from "../../../utils/Browser/keyCodes";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function SelectionBubble(_ref) {
  let {
    className = '',
    id = '',
    label,
    style = {},
    title = '',
    selected,
    hideClose = false,
    onClick,
    onLabelClick = null,
    clickable = false
  } = _ref;
  const handleClick = () => {
    onClick(selected);
  };
  const onKeyDown = e => {
    if (isKeyPressed(e, 'Enter', RETURN_KEY_CODE) || isKeyPressed(e, ' ', SPACEBAR_KEY_CODE)) {
      e.preventDefault();
      handleClick();
    }
  };
  const handleLabelClick = () => {
    if (onLabelClick && clickable) {
      onLabelClick(selected);
    }
  };
  const buttonClass = () => cn('flex-auto text-action-blue', {
    'hover:underline': clickable,
    'pointer-events-none': !clickable
  });
  return /*#__PURE__*/_jsx("div", {
    id: id,
    className: `bg-medium-fill-blue rounded-full border border-action-blue inline-block mb-1.5 mr-2.5 px-3 py-1 select-none leading-4 text-xs font-regular-font ${className}`,
    style: style,
    title: title,
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex items-center",
      children: [/*#__PURE__*/_jsx("button", {
        className: buttonClass(),
        onClick: handleLabelClick,
        "aria-label": label,
        tabIndex: hideClose ? 0 : -1,
        role: "button",
        children: label
      }), !hideClose && /*#__PURE__*/_jsx("button", {
        type: "button",
        tabIndex: 0,
        "aria-label": `Remove ${label}`,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        className: "bg-transparent cursor-pointer ml-2 text-action-blue hover:text-deep-blue p-0 border-0",
        children: /*#__PURE__*/_jsx(Icon, {
          icon: "Cross",
          size: 8,
          color: "action-blue",
          "aria-hidden": "true"
        })
      })]
    })
  });
}
SelectionBubble.propTypes = {
  className: PropTypes.string,
  hideClose: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  onLabelClick: PropTypes.func,
  style: PropTypes.object,
  selected: PropTypes.object.isRequired,
  title: PropTypes.string,
  clickable: PropTypes.bool
};
export default SelectionBubble;
//# sourceMappingURL=SelectionBubble.js.map